import FeatureOrUpgradeButton from 'garaje/pods/components/feature-or-upgrade-button/component';

export default class FeatureOrHide extends FeatureOrUpgradeButton {}
